import React from 'react'

import { Formik } from 'formik'

import * as FormGroups from './formGroups'

const FilaTemplate = ({ index, defaultData, actualizarFilaHandler, flagUltimo, cuotasRef, fechaEmisionDocumento }) => {
  const formInitialValues = React.useMemo(() => {
    return {
      orden: index + 1,
      plazoDias: defaultData.plazoDias || '',
      fecha: defaultData.fecha || '',
      monto: defaultData.monto || ''
    }
  }, [index, defaultData])

  return (
    <Formik initialValues={formInitialValues}>
      {({ isSubmitting, errors, touched, values, handleBlur, setFieldValue, handleChange, setValues }) => (
        <tr>
          <td>{values.orden}</td>
          <td>
            <FormGroups.PlazoDiasFormGroup
              iTouched={touched.plazoDias}
              iError={errors.plazoDias}
              fIsSubmitting={isSubmitting}
              index={index}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              values={values}
              actualizarFilaHandler={actualizarFilaHandler}
              cuotasRef={cuotasRef}
              fechaEmisionDocumento={fechaEmisionDocumento}
            />
          </td>
          <td>
            <FormGroups.FechaFormGroup
              iTouched={touched.fecha}
              iError={errors.fecha}
              fIsSubmitting={isSubmitting}
              index={index}
              values={values}
              actualizarFilaHandler={actualizarFilaHandler}
              cuotasRef={cuotasRef}
              handleChange={handleChange}
              setValues={setValues}
              fechaEmisionDocumento={fechaEmisionDocumento}
            />
          </td>
          <td>
            <FormGroups.MontoFormGroup
              iTouched={touched.monto}
              iError={errors.monto}
              fIsSubmitting={isSubmitting}
              index={index}
              handleBlur={handleBlur}
              values={values}
              actualizarFilaHandler={actualizarFilaHandler}
              flagUltimo={flagUltimo}
            />
          </td>
        </tr>
      )}
    </Formik>
  )
}

export default React.memo(FilaTemplate)
